import { RiskRegisterAssessmentStatusEnum } from 'src/app/enums/assessmentStatus.enum';

export const APPROVED_RISK_REGISTER_STATUSES: readonly RiskRegisterAssessmentStatusEnum[] = [
    RiskRegisterAssessmentStatusEnum.AutoApproved,
    RiskRegisterAssessmentStatusEnum.ApprovedWithException,
    RiskRegisterAssessmentStatusEnum.Approved,
];

export const EDITABLE_RISK_REGISTER_STATUSES: readonly RiskRegisterAssessmentStatusEnum[] = Object.values(
    RiskRegisterAssessmentStatusEnum,
).filter(
    (status): status is RiskRegisterAssessmentStatusEnum =>
        typeof status === 'number' && !APPROVED_RISK_REGISTER_STATUSES.includes(status),
);

export const APPROVED_REGISTER_BLOCKED_TEXT = "Approved registers can't be edited. Change their status to Draft first.";

export const APPROVED_REGISTER_BULK_HINT_TEXT =
    "Approved registers can't be edited here. Use Change Status in the bulk toolbar to set them to Draft first.";

export function isApprovedRiskRegisterStatus(status: RiskRegisterAssessmentStatusEnum | null | undefined): boolean {
    return status != null && APPROVED_RISK_REGISTER_STATUSES.includes(status);
}
